import { buttonClasses } from '@mui/material/Button';
import { dialogActionsClasses } from '@mui/material/DialogActions';
import { pickersDayClasses } from '@mui/x-date-pickers/PickersDay';

const datePickerCalendarStyles = (theme) => ({
  [`& .${pickersDayClasses.root}`]: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: theme.palette.gold.main,
      color: theme.palette.ink.main,
      fontWeight: 800
    },
    // El focus por defecto de MUI pinta el día con primary.dark (círculo oscuro que
    // "no se nota"); lo reemplazamos por el acento dorado suave del design system.
    '&:focus, &.Mui-focusVisible': {
      backgroundColor: theme.palette.gold.soft,
      color: theme.palette.gold.main
    },
    [`&.${pickersDayClasses.selected}`]: {
      backgroundColor: theme.palette.gold.main,
      color: theme.palette.ink.main,
      fontWeight: 800,
      '&:hover, &:focus': {
        backgroundColor: theme.palette.gold.main,
        color: theme.palette.ink.main
      }
    },
    [`&.${pickersDayClasses.today}`]: {
      border: `1px solid ${theme.palette.gold.main}`
    }
  },
  '& .MuiPickersYear-yearButton': {
    '&.Mui-selected': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.black.main,
      fontWeight: 800,
      '&:hover, &:focus': {
        backgroundColor: theme.palette.secondary.main
      }
    },
    '&.Mui-disabled': {
      color: theme.palette.text.disabled
    }
  },
  [`& .${dialogActionsClasses.root}`]: {
    [`& .${buttonClasses.text}`]: {
      color: theme.palette.secondary.main
    }
  }
});

export default datePickerCalendarStyles;
